import React from 'react';
import PropTypes from 'prop-types';

const IconArrow = ({ width = 33, height = 6, color = 'none' }) => {
    return <svg width={width} height={height} viewBox='0 0 33 6' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M32.75 3L27.75 0.113248L27.75 5.88675L32.75 3ZM1.25 2.5C0.973858 2.5 0.75 2.72386 0.75 3C0.75 3.27614 0.973858 3.5 1.25 3.5L1.25 2.5ZM28.25 3L28.25 2.5L1.25 2.5L1.25 3L1.25 3.5L28.25 3.5L28.25 3Z' fill={color} />
    </svg>;
};

IconArrow.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    color: PropTypes.string
};
export default React.memo(IconArrow);
